import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CallbackPage from './components/auth/CallbackPage';
import SilentRenewPage from './components/auth/SilentRenewPage';
import './index.css';
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
TimeAgo.addDefaultLocale(en);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          {/* For OAuth */}
          <Route path="/signin-callback" element={<CallbackPage />} />
          <Route path="/silent-renew" element={<SilentRenewPage />} />
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter >
    </Provider >
  </React.StrictMode>
);